import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CustomformComponent } from '../../../catalog/customform/customform.component';
import { CMS_COMPONENT_CUSTOM_FORM_CONFIG } from './cms-component-custom-form.config';
import { NCmsComponentCustomForm } from './cms-component-custom-form.interface';

@Component({
    selector: 'cms-component-custom-form',
    templateUrl: './cms-component-custom-form.component.html',
    standalone: true,
    imports: [CustomformComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentCustomFormComponent>(CMS_COMPONENT_CUSTOM_FORM_CONFIG)
export class CmsComponentCustomFormComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentCustomForm.IData;
}
